// extracted by mini-css-extract-plugin
module.exports = {"label":"counter_label__2ozMD","counter_wrapper":"counter_counter_wrapper__3_gl8","input":"counter_input__Cytny"};